import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { LogoBanner } from './components/LogoBanner';
export function App() {
  return <div className="bg-aspira-white min-h-screen" data-id="element-0">
      <LogoBanner data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <ContactSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}